import Config from '../../Config'
let { Language, platform } = Config()
const Languageobj = {
    M1: 'cn',
    M2: 'th',
    M3: 'vn'
}
let special = Language == 'M1' && platform == 'Mobile' ? '/mobile' : ''
let code = Languageobj[Language]


const Icons = {
    back: '/' + code + special + '/img/CustomerService/back.png',
    calendar: '/' + code + special + '/img/CustomerService/calendar.png',
    calendar1: '/' + code + special + '/img/CustomerService/calendar1.png',
    contact: '/' + code + special + '/img/CustomerService/contact.png',
    delete: '/' + code + special + '/img/CustomerService/delete.png',
    modalClose: '/' + code + special + '/img/CustomerService/modalClose.png',
    general: '/' + code + special + '/img/CustomerService/general.png',
    noData: '/' + code + special + '/img/CustomerService/noData.png',
    photo1: '/' + code + special + '/img/CustomerService/photo1.png',
    photo2: '/' + code + special + '/img/CustomerService/photo2.png',
    search: '/' + code + special + '/img/CustomerService/search.png',
    // searchBg: '/' + code + special + '/img/CustomerService/searchBg.jpg',
    searchMobileBg: '/' + code + special + `/img/CustomerService/search${platform}${code}Bg.jpg`,
    searchWebBg: '/' + code + special + `/img/CustomerService/search${platform}${code}Bg.jpg`,
    submission: '/' + code + special + `/img/CustomerService/submission${platform}${code}Bg.jpg`,
    upload: '/' + code + special + '/img/CustomerService/upload.png',
    error1: '/' + code + special + '/img/CustomerService/error1.png',
    rightArrow: '/' + code + special + '/img/CustomerService/rightArrow.png',
    CustomerServiceClose: '/' + code + special + '/img/CustomerService/CustomerService-close.png',
    'star-ai': '/' + code + special + '/img/CustomerService/star-ai.png',





    back: '/' + code + special + '/img/CustomerService/back.png',
    back: '/' + code + special + '/img/CustomerService/back.png',
    back: '/' + code + special + '/img/CustomerService/back.png',
    back: '/' + code + special + '/img/CustomerService/back.png',
    back: '/' + code + special + '/img/CustomerService/back.png',
}


export default Icons